import React from 'react';
import MainLogo from '../../images/white-logo.png';
import './PageLoader.scss';

interface PageLoaderProps {
  text?: string;
  size?: 'small' | 'medium' | 'large';
}

const PageLoader: React.FC<PageLoaderProps> = ({ 
  text = 'Loading', 
  size = 'medium' 
}) => {
  return (
    <div className={`page-loader ${size}`}>
      <div className="loader-content">
        {/* Logo with pulse animation */}
        <div className="logo-container">
          <img src={MainLogo} alt="Gifts From Heaven" className="loader-logo" />
          <div className="logo-glow"></div>
        </div>
        
        {/* Animated spinner */}
        <div className="spinner-container">
          <div className="spinner">
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
          </div>
        </div>
        
        {/* Loading text */}
        <div className="loader-text">
          <span className="loading-text">{text}</span>
          <div className="dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
        
        {/* Progress bar */}
        {/* <div className="progress-container">
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default PageLoader;